import { render, staticRenderFns } from "./FrameworkAdminLayout.vue?vue&type=template&id=00ffe588"
import script from "./FrameworkAdminLayout.vue?vue&type=script&lang=js"
export * from "./FrameworkAdminLayout.vue?vue&type=script&lang=js"
import style0 from "./FrameworkAdminLayout.vue?vue&type=style&index=0&id=00ffe588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports